module.exports = __webpack_public_path__ + "static/media/screenshot4_new.1ea1b2f3.png";